import { SafeModule } from '../../../../../../../shared/pipe/safe/safe.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CabecalhoEsquerdaComponent } from './cabecalho-esquerda.component';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';

@NgModule({
  declarations: [
      CabecalhoEsquerdaComponent
  ],
  imports: [
    TranslateModule,
    CommonModule,
    RouterModule,
    LocalizeRouterModule,
    SafeModule
  ],
  exports: [
    CabecalhoEsquerdaComponent
  ]
})

export class CabecalhoEsquerdaModule { }
